import { ForgeProjectContext } from "./SDKForgeProjectContext";
export class ForgeProject {
    constructor(model) {
        var _a;
        this.createdAt = new Date(model.createdAt);
        this.createdByUserId = model.createdByUserId;
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : undefined;
        this.id = model.id;
        this.instruction = model.instruction;
        this.meta = model.meta;
        this.name = model.name;
        this.context = new ForgeProjectContext(model.context);
        this.tags = model.tags;
        this.workspaceId = model.workspaceId;
        this.accessMode = model.accessMode;
        this.isArchived = (_a = model.isArchived) !== null && _a !== void 0 ? _a : false;
        this.emoji = model.emoji;
        this.defaultRole = model.defaultRole;
    }
    toRemote() {
        var _a;
        return Object.assign(Object.assign({}, this), { context: this.context.toRemote(), createdAt: this.createdAt.toISOString(), updatedAt: (_a = this.updatedAt) === null || _a === void 0 ? void 0 : _a.toISOString() });
    }
}
